import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import DateFnsUtils from '@date-io/date-fns';
import {
  Box,
  Button,
  Grid,
  Link,
  TextField,
  Typography,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  KeyboardTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import deLocale from 'date-fns/locale/es';

import { ReactComponent as CalendarIcon } from '../../../../../../assets/img/calendar.svg';
import { ReactComponent as TimeIcon } from '../../../../../../assets/img/reloj.svg';
import WhatsappSrc from '../../../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../../../assets/img/whatsapp.png';
import SubHeader from '../../../../../../components/Header/SubHeader.component';
import Loader from '../../../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../../../config/app';
import { useAuthDataContext } from '../../../../../../context/auth/auth.provider';
import { useIncidentsContext } from '../../../../../../context/incidents/incidents.provider';
import {
  SINISTER_INSPECTION_QUERY,
  sinisterInspectionQuery,
} from '../../../../../../query/sinisterInspections/sinisterInspections';

const CoordinatedInspection = () => {
  const { incident } = useIncidentsContext();
  const [retryModal, setRetryModal] = useState(false);
  const history = useHistory();

  const { data, isLoading } = useQuery(
    [SINISTER_INSPECTION_QUERY, { id: incident.id }],
    sinisterInspectionQuery,
    {
      onError: (err: any) => {
        setRetryModal(true);
      },
    }
  );

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  /* Fecha y hora */
  const handleDateChange = (date: any) => {};

  return (
    <>
      <Box display={isLoading ? 'block' : 'none'}>
        <Loader action={'Cargando'}></Loader>
      </Box>

      <SubHeader
        content={
          <Box>
            <Typography variant="h6">Inspeccion Coordinada</Typography>
          </Box>
        }
      ></SubHeader>

      <SharedDialog
        open={retryModal}
        onClose={redirectHome}
        content={
          <Box>
            <Typography variant="h6" style={{ marginBottom: '15px' }}>
              Ha ocurrido un error.
            </Typography>
            <Typography>
              ¡Lo sentimos! Ha ocurrido un error. Por favor vuelve a intentarlo
              luego.
            </Typography>
          </Box>
        }
        actions={
          <Grid container justify="center">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={redirectHome}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <Grid container justify="center">
        <Grid item xs={11}>
          <Box mt={4}>
            <Typography variant="h6">Datos del vehículo</Typography>
          </Box>

          <Box mb={1}>
            <Typography variant="subtitle2">Vehículo</Typography>
            <TextField
              disabled
              type="text"
              size="small"
              fullWidth={true}
              name="vehicle"
              id="vehicle"
              placeholder="Vehículo"
              variant="outlined"
              value={`${
                incident?.item?.brand +
                ' ' +
                incident?.item?.model?.split(' ')[0]
              } - Patente ${incident?.item.license_plate}`}
            />
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box mt={2}>
            <Typography variant="h6">Datos del taller</Typography>
          </Box>

          <Box mb={2}>
            <Typography variant="subtitle2">Nombre del taller</Typography>
            <TextField
              disabled
              type="text"
              size="small"
              fullWidth={true}
              name="email"
              id="email"
              placeholder="No se ingresó información"
              variant="outlined"
              value={data?.repair_shop_name || ''}
            />
          </Box>

          <Box mb={2}>
            <Typography variant="subtitle2">Email</Typography>
            <TextField
              type="email"
              size="small"
              fullWidth={true}
              name="email"
              id="email"
              placeholder="No se ingresó información"
              variant="outlined"
              value={data?.repair_shop_email || ''}
              defaultValue={data?.repair_shop_email}
              disabled
            />
          </Box>

          <Box mb={2} mt={2}>
            <Typography variant="subtitle2">Teléfono *</Typography>
            <TextField
              type="number"
              size="small"
              fullWidth={true}
              name="phone_number"
              id="phone_number"
              placeholder="No se ingresó información"
              variant="outlined"
              value={data?.repair_shop_phone || ''}
              disabled
            />
          </Box>
        </Grid>

        <Grid item xs={11}>
          <Box mt={2}>
            <Typography variant="h6">Datos del lugar</Typography>
          </Box>

          <Grid item xs={12} sm={6}>
            <Box>
              <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
                <Grid item xs={12} sm={6}>
                  <Box mb={2}>
                    <Typography variant="subtitle2">Fecha *</Typography>
                    <KeyboardDatePicker
                      style={{ backgroundColor: 'white' }}
                      variant="inline"
                      inputVariant="outlined"
                      format="dd/MM/yyyy"
                      margin="normal"
                      id="date-picker"
                      value={data?.meeting_date || ''}
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      disabled
                      keyboardIcon={<CalendarIcon />}
                      InputProps={{ readOnly: true }}
                      fullWidth
                    />
                  </Box>

                  <Box mb={2}>
                    <Typography variant="subtitle2">De</Typography>
                    <KeyboardTimePicker
                      fullWidth={true}
                      inputVariant="outlined"
                      margin="normal"
                      id="time-picker"
                      ampm
                      value={new Date('December 17, 1995 08:00:00')}
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        'aria-label': 'change time',
                      }}
                      keyboardIcon={<TimeIcon />}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Box>

                  <Box mb={2}>
                    <Typography variant="subtitle2">A</Typography>
                    <KeyboardTimePicker
                      fullWidth={true}
                      inputVariant="outlined"
                      margin="normal"
                      id="time-picker"
                      ampm
                      value={new Date('December 17, 1995 18:00:00')}
                      onChange={handleDateChange}
                      KeyboardButtonProps={{
                        'aria-label': 'change time',
                      }}
                      keyboardIcon={<TimeIcon />}
                      InputProps={{ readOnly: true }}
                      disabled
                    />
                  </Box>
                </Grid>
              </MuiPickersUtilsProvider>
            </Box>
          </Grid>

          {/* Falta Autocomplete "Lugar" */}

          <Grid item xs={11}>
            <Box mb={2}>
              <Typography variant="subtitle2">Entre calles</Typography>
              <TextField
                type="text"
                size="small"
                fullWidth={true}
                name="email"
                id="email"
                placeholder="No se ingresó información"
                variant="outlined"
                value={data?.between_streets || ''}
                disabled
              />
            </Box>
          </Grid>

          <Grid item xs={11}>
            <Box mb={2}>
              <Typography variant="subtitle2">Información adicional</Typography>
              <TextField
                //defaultValue={sinister_body.fact}
                id="outlined-multiline-static"
                multiline
                fullWidth
                size="medium"
                rows={8}
                placeholder="No se ingresó información"
                variant="outlined"
                value={data?.street_extra || ''}
                disabled
              />
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={11}>
          <Box my={2}>
            <Typography variant="h6">IMPORTANTE</Typography>
            <Box my={2}>
              <Typography color="textSecondary">
                Si necesitás modificar o cancelar tu inspección, te pedimos que
                nos contactes por Whatsapp.
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box m={2}>
            <Link
              href={appConfig?.WHATSAPP_LINK}
              rel="noopener"
              target="_blank"
            >
              <Button variant="outlined" fullWidth color="secondary">
                <Box m={1}>
                  <img
                    src={WhatsappSrc}
                    alt="Whatsapp"
                    style={{ marginLeft: '15px', marginRight: '15px' }}
                  />
                </Box>
                <Typography display="inline">
                  Comunicarme vía Whatsapp
                </Typography>
              </Button>
            </Link>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default CoordinatedInspection;
